export const OrderPlacedSource = {
    navigationPrecondition: 'navigationPrecondition',
    suggestedWorkup: 'suggestedWorkup',
    addDataPanel: 'addDataPanel',
};
//# sourceMappingURL=types.js.map